export enum PlaybookTemplateKey {
  powerplatformSilentRemediation = 'powerplatformSilentRemediation',
  powerplatformAgentSetAuthentication = 'powerplatformAgentSetAuthentication',
  powerplatformRemoveOrgWideAccess = 'powerplatformRemoveOrgWideAccess',
  powerplatformRemoveOrgWideAccessApps = 'powerplatformRemoveOrgWideAccessApps',
  powerplatformRemoveOrgWideAccessConnections = 'powerplatformRemoveOrgWideAccessConnections',
}
